import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "./card";
import { useReportsStatistics } from "../content/hooks/useReportsStatistics";
import { DownloadsStatusCard } from "./downloads-status-card";

export const DashboardHeader: React.FC = () => {
  const { t } = useTranslation();
  const reportsStatistics = useReportsStatistics();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm md:text-base">
            {t("dashboard.totalReportsCreated")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl md:text-4xl">
            {reportsStatistics.status === "pending" ? (
              <div className="animate-pulse bg-gray-200 h-8 w-16 rounded"></div>
            ) : reportsStatistics.status === "error" ? (
              <span className="text-red-500">-</span>
            ) : (
              reportsStatistics.data.totalReports
            )}
          </div>
        </CardContent>
      </Card>
      <DownloadsStatusCard {...reportsStatistics} />
    </div>
  );
};
